import React, { useState } from "react";
import { useFornecedores } from "../../services";
import { Fornecedores } from "../../types";
import { CModal } from "../data-display";

import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import { memoObserver } from "../../utils/memoObserver.utils";
import {
  FormFornecedores,
  FormFornecedoresRef,
} from "./form-fornecedores.component";
import { useStores } from "../contexts/store-provider.context";

export const ModalFormFornecedores = memoObserver(() => {
  const { addFornecedor } = useFornecedores();
  const formRef = React.useRef<FormFornecedoresRef>(null);
  const [open, setOpen] = useState(false);
  const { fornecedoresStore } = useStores();

  const onSubmit = async (values: Fornecedores) => {
    try {
      addFornecedor(values);
    } catch (err) {
      console.log(err);
    } finally {
      handleClose();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <AddIcon />
      </IconButton>
      <CModal
        title="Novo Fornecedor"
        onSave={() => {
          formRef.current?.submit();
        }}
        open={open}
        onClose={() => handleClose()}
        loading={fornecedoresStore.crudLoading["add"]}
      >
        <FormFornecedores ref={formRef} onSubmit={onSubmit} />
      </CModal>
    </>
  );
});
